export default __webpack_public_path__ + "930bb9d0e52f1e253e09ef902428d2b5.svg";